import ConnectorType, { getConnectorTypeSvg } from 'components/ConnectorType';
import IntlMessages from 'util/IntlMessages';

import { type InfoProps } from '../VehicleInfo';

const ConnectorInfo = ({ connector, status }: InfoProps) => (
  <div className="d-flex flex-column ml-4">
    <h3 className="mb-3">
      <b>{connector?.verbose_name || '- - -'}</b>
    </h3>
    <h6 className="color-bg-lightest text-uppercase mb-3 d-flex align-items-center">
      <div className="mr-2 connector-type-icon">{getConnectorTypeSvg(connector)}</div>
      <b>{connector?.plug_type || '- - -'}</b>
    </h6>
    <h6 className="color-bg-lightest text-uppercase d-flex align-items-center">
      <div className="mr-2">
        <ConnectorType connector={connector} />
      </div>
      <b>
        <IntlMessages id={`common.labels.${status?.toLowerCase()}`} />
      </b>
    </h6>
  </div>
);

export default ConnectorInfo;
